import React from 'react';

const Step5_Complete = ({ summary, onRestart }) => {
  const updated = summary?.updated || 0;
  const failed = summary?.failed || 0;
  const clinicId = summary?.clinicId || '';

  const handleViewDoctors = () => {
    if (!clinicId) return;
    window.location.href = `/clinics/${clinicId}#doctors`;
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Complete</h2>
        <p className="text-gray-600">Doctor services updated successfully.</p>
      </div>

      <div className={`rounded-lg p-6 text-center ${failed > 0 ? 'bg-yellow-50 border border-yellow-200' : 'bg-green-50 border border-green-200'}`}>
        <p className={`font-semibold text-lg ${failed > 0 ? 'text-yellow-800' : 'text-green-800'}`}>
          {failed > 0 ? 'Update Completed with Errors' : 'Update Completed'}
        </p>
        <p className={failed > 0 ? 'text-yellow-900 mt-1' : 'text-green-900 mt-1'}>
          Updated {updated} doctor{updated !== 1 ? 's' : ''}.
          {failed > 0 && ` ${failed} failed.`}
        </p>
        {clinicId && (
          <p className="text-sm text-green-800 mt-1">
            Clinic: <span className="font-mono">{clinicId}</span>
          </p>
        )}
      </div>

      <div className="flex flex-wrap justify-center gap-4">
        <button
          type="button"
          onClick={onRestart}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Start New Update
        </button>
        {clinicId && (
          <button
            type="button"
            onClick={handleViewDoctors}
            className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            View Doctors
          </button>
        )}
      </div>
    </div>
  );
};

export default Step5_Complete;
